exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opacity0[data-v-39fe5118]{opacity:0}.wrapper-name[data-v-39fe5118]{display:flex;white-space:nowrap}.wrapper-name .name[data-v-39fe5118]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
